export const memberFile = "lotto_members.json";
export const lottoPoolInfoFile = "lotto_general.json";
